var window=global;var $CLJS=require("./cljs_env");require("./cljs_env.js");
'use strict';$CLJS.Nh=require("moment");module.exports=$CLJS.Nh;